import { render } from "./scene1.vue?vue&type=template&id=38ab51e5&scoped=true&bindings={\"isActive\":\"data\",\"change\":\"options\",\"closeModal\":\"options\"}"
import script from "./scene1.vue?vue&type=script&lang=js"
export * from "./scene1.vue?vue&type=script&lang=js"

import "./scene1.vue?vue&type=style&index=0&id=38ab51e5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38ab51e5"

export default script